import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { configurableAttributeCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-attribute-code.engine';
import { configurableMismatchCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-missmatch.engine';
import { configurableStockCodeEngine } from '@df/module-product-configuration/model/configurable/options/engines/configurable-stock.engine';
import { NProductConfiguration } from '@df/module-product-configuration/df-module-product-configuration.interfaces';
import { getProductConfigurationProviders } from '@df/module-product-configuration/provider/product-configuration.providers';
import { UiComponent } from '@df/ui/ui.component';
import { BehaviorSubject } from 'rxjs';
import { Product } from '../product.decorator';
import { ProductViewLayoutComponent } from './layout/product-view-layout.component';
import { BasketNotificationBarComponent } from '../../../basket/notification-bar/basket-notification-bar.component';
import minBy from 'lodash/minBy';

function chooseCheapestChild(
    matchResult: NProductConfiguration.Configurable.ChildrenMatchResult,
    _selection: NProductConfiguration.Configurable.Selection
) {
    return minBy(matchResult.children, child => child.price);
}

@Component({
    standalone: true,
    imports: [forwardRef(() => ProductViewLayoutComponent), BasketNotificationBarComponent],
    selector: 'product-view',
    templateUrl: './product-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: getProductConfigurationProviders({
        component: ProductViewComponent as any,
        metaIntegration: true,
        configurable: () => ({
            order: ['size', 'thickness', 'color'],
            urlModel: 'child',
            metaModel: 'child',
            selection: {
                default: {
                    onMismatch: 'change',
                    onPartial: 'simple'
                }
            },
            chooseChild: chooseCheapestChild,
            optionsEngines: [
                configurableMismatchCodeEngine({ logic: 'error' }),
                configurableAttributeCodeEngine({ codes: ['color'], logic: 'include' }),
                configurableStockCodeEngine({ logic: 'error' })
            ]
        })
    })
})
export class ProductViewComponent extends UiComponent {
    @Input({
        required: true
    })
    model!: Product<IProductDataV3>;

    protected get parent() {
        return this.model.parent as Product<IProductDataV3>;
    }

    readonly model$ = new BehaviorSubject<Product<IProductDataV3> | undefined>(undefined);

    override ngOnChanges(changes: any): void {
        if (this.model$.value !== this.model) {
            this.model$.next(this.model);
        }
        super.ngOnChanges(changes);
    }
}
